import React from "react";

interface SpinnerProps {
  size?: "small" | "medium" | "large";
  color?: "gray" | "white" | "blue" | "green" | "gold";
}

const Spinner: React.FC<SpinnerProps> = ({ size = "medium", color = "gray" }) => {
  const sizeClasses = {
    small: "w-3 h-3 border-[1.5px]",
    medium: "w-5 h-5 border-2",
    large: "w-8 h-8 border-2",
  };

  const colorClasses = {
    gray: "border-gray-300 border-t-gray-600",
    white: "border-white/30 border-t-white",
    blue: "border-blue-300 border-t-blue-600",
    green: "border-green-300 border-t-green-600",
    gold: "border-[#e0bb84]/30 border-t-[#e0bb84]",
  };

  return (
    <div
      className={`${sizeClasses[size]} ${colorClasses[color]} rounded-full animate-spin`}
    />
  );
};

export default Spinner;
